import axios from 'axios'

export const state = {
  items: [],
}

export const getters = {}

export const mutations = {}

export const actions = {
  fetchOLOItems({ commit, state }, { params }) {
    return axios
      .get(`/v1/oloMenuItems/`, {
        params: params,
      })
      .then(response => {
        const items = response.data
        if (items.length > 0) {
          return items
        } else {
          return 'No items'
        }
      })
      .catch(err => {
        throw err
      })
  },

  insertModiferItem({ commit, state }, { itemObject }) {
    return axios
      .post(`v1/oloMenuItems/insertmodifierItem`, itemObject)
      .then(response => {
        return response.data
      })
  },

  UpdateModiferItem({ commit, state }, { itemObject }) {
    return axios
      .put(`v1/oloMenuItems/updatemodifierItem`, itemObject)
      .then(response => {
        return response.data
      })
  },

  updateOLOItem({ commit, state }, { itemObject }) {
    let config = {
      header: {
        'Content-Type': 'multipart/form-data',
      },
    }

    return axios
      .post(`v1/oloMenuItems/update`, itemObject, config)
      .then(response => {
        return response.data
      })
  },

  insertModiferItemtoItemDoc({ commit, state }, { itemObject }) {
    return axios
      .post(`v1/oloMenuItems/insertmodifierItemtoItemDoc`, itemObject)
      .then(response => {
        return response.data
      })
  },

  updateModiferItem({ commit, state }, { itemObject }) {
    return axios
      .put(`v1/oloMenuItems/insertmodifierItemUpdate`, itemObject)
      .then(response => {
        return response.data
      })
  },

  insertItem({ commit, state }, { itemObject }) {
    return axios.post(`v1/oloMenuItems/`, itemObject).then(response => {
      return response.data
    })
  },
}
